import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENTID,
    authority: process.env.REACT_APP_TENANTURL,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: "/logout", // Optional: Where to redirect after logout
    navigateToLoginRequestUrl: true, // Recommended for SPAs
  },
  cache: {
    cacheLocation: "sessionStorage", // Or 'localStorage' if persistence across sessions is needed
    storeAuthStateInCookie: false, // Set to true for IE11 support, false otherwise
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message); // Can be verbose
            return;
          case LogLevel.Verbose:
            // console.debug(message); // Very verbose
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Info, // Adjust log level as needed
    },
  },
};

// Define the scopes needed for MS Graph API calls
// Start with basic scopes for login, add more as needed
export const loginRequest = {
  scopes: ["openid", "profile", "User.Read"],
};

// Define the scopes needed specifically for sending email
export const mailSendRequest = {
  scopes: ["Mail.Send"],
};

// Optional: Define scopes for reading user profile info via Graph
export const graphMeEndpoint = "https://graph.microsoft.com/v1.0/me";
